export const todayGoalsAvailable=user=>['boutique_manager','owner','coo','cfo','district_leader'].includes(user?.role);
